function assetPackAccess () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/asset-pack-access/asset-pack-access-dialog.html?$$REVISION$$'
  }
}
export { assetPackAccess }
